import { Navigate } from "react-router-dom";
import { getCookie, isMobileView } from "./Utility";
export const AuthPrivateRoute = ({ children }) => {
  const userlog =
    getCookie("userlog") !== "" ? JSON.parse(getCookie("userlog")) : null;

  if (userlog) {
    return <Navigate to="/" />;
  }

  return children;
};

export const StorePrivateRoute = ({ children }) => {
  const userlog =
    getCookie("userlog") !== "" ? JSON.parse(getCookie("userlog")) : null;
  if (!userlog) {
    return <Navigate to="/auth" />;
  }

  return children;
};

export const CustomerPrivateRoute = ({ children }) => {
  const customerlog = sessionStorage.getItem("customerlog");
  const id = getCookie("franchiseid");

  console.log(isMobileView, id, "isStartUrl");

  // An active customer session takes precedence over a stale shop redirect.
  if (customerlog) {
    return children;
  }

  // Franchise shop redirect
  if (id && id.trim() !== "") {
    console.log("isStartUrl0");
    return <Navigate to={`/kansas_product/shop/${id}`} replace />;
  }

  // 🔥 Allow PWA to load restore page on first open
  if (isMobileView) {
    console.log("isStartUrl1");
    return children;
  }

  // Normal auth in browser
  console.log("isStartUrl2");
  return <Navigate to="/" />;
};

export const VerifyPrivateRoute = ({ children }) => {
  const verifyStatus = sessionStorage.getItem("otpStatus");
  if (verifyStatus !== null) {
    return <Navigate to="/store" />;
  }
  return children;
};
